import React, {Component} from 'react';
import {LoaderSmall} from "../../../loader";
import MapCanvas from "../../modal-global/map-dialog/map-canvas";

class DragAndDrop extends Component {

    addMarker = (e) => {
        this.props.addMarker({
            Longitude: e.latlng.lng,
            Latitude: e.latlng.lat
        })
    }


    render() {
        return (
            <div className={this.props.className ?? "w-full h-[960px] max-h-[calc(100vh-32rem)] relative z-0"}>
                {!!this.props.isLoading && (
                    <div className="inset-0 absolute flex items-center justify-center">
                        <div className="text-center">
                            <LoaderSmall/>

                            {!!this.props.loaderMessage && (
                                <p className="mt-2 font-bold text-base text-tm-gray-700">{this.props.loaderMessage}</p>
                            )}
                        </div>
                    </div>
                )}

                <MapCanvas
                    data={
                        this.props.Latitude && this.props.Longitude
                            ? {Latitude: this.props.Latitude, Longitude: this.props.Longitude}
                            : undefined
                    }
                    onClick={this.addMarker}
                    center={[40, -100]}
                    zoom={5}
                />
            </div>
        )
    }
}

export default DragAndDrop;
